"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var MessageHelper_1 = require("./MessageHelper");
var RadioButton_1 = require("./RadioButton");
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t.custom-control {\n\t\t", "\n\t}\n\t&.radio-series {\n\t\t.custom-radio {\n\t\t\tmin-height: auto;\n\t\t\tmargin-bottom: 20px;\n\t\t}\n\t\t.tws-input-radio-label {\n\t\t\tfont-size: 13.5px;\n\t\t\tline-height: 1.3em;\n\t\t}\n\t}\n"], ["\n\t.custom-control {\n\t\t", "\n\t}\n\t&.radio-series {\n\t\t.custom-radio {\n\t\t\tmin-height: auto;\n\t\t\tmargin-bottom: 20px;\n\t\t}\n\t\t.tws-input-radio-label {\n\t\t\tfont-size: 13.5px;\n\t\t\tline-height: 1.3em;\n\t\t}\n\t}\n"])), function (props) { return (props.alignDirection === 'Horizontal' ? 'display: inline-block;' : ''); });
Container.displayName = 'Container';
var Radio = /** @class */ (function (_super) {
    __extends(Radio, _super);
    function Radio(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: _this.props.value,
            items: _this.props.items ? _this.props.items : [],
        };
        _this.toggle = _this.toggle.bind(_this);
        return _this;
    }
    Radio.prototype.toggle = function (event) {
        if (this.props.disabled) {
            return;
        }
        event.preventDefault();
        var value = event.currentTarget.querySelector('input').value;
        this.setState({ value: value });
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };
    Radio.prototype.render = function () {
        var _this = this;
        return (React.createElement(Container, { showTooltips: this.props.showTooltips, alignDirection: this.props.alignDirection, className: 'tws-input-radio-wrapper ' + (this.props.series ? 'radio-series' : '') },
            this.state.items &&
                this.state.items.map(function (item) { return (React.createElement(RadioButton_1.RadioButton, { groupName: _this.props.name, isChecked: _this.state.value === item.name, key: item.name, size: _this.props.size, className: _this.props.className, disabled: _this.props.disabled, item: item, handleChange: _this.toggle, showTooltips: _this.props.showTooltips ? _this.props.showTooltips : false })); }),
            this.getExtraMessage()));
    };
    Radio.prototype.getExtraMessage = function () {
        if (this.props.error) {
            return MessageHelper_1.MessageHelper.getFormattedErrorMessages(this.props.message);
        }
        if (this.props.success) {
            return MessageHelper_1.MessageHelper.getFormattedSuccessMessages(this.props.message);
        }
        return null;
    };
    Radio.defaultProps = {
        alignDirection: 'Vertical',
    };
    return Radio;
}(React.Component));
exports.Radio = Radio;
var templateObject_1;
